import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { successToast, errorToast } from "../../Utils/toast";
import { useCreateLocationMutation } from "../../redux/services/locationService/location.Services";
// ✅ ADD IMPORTS
import { useGetCityQuery } from "../../redux/services/cityService/city.Services";
import { useGetStateQuery } from "../../redux/services/stateService/state.Services";

function AddLocation() {

    const navigate = useNavigate();
    const [createLocation, { isLoading }] = useCreateLocationMutation()
    const { data: stateData } = useGetStateQuery();
    const { data: cityData } = useGetCityQuery();
    const [formData, setFormData] = useState({
        name: "",
        stateName: '',
        cityName: "",
        status: "active",
    });


    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

    };

    // SUBMIT
    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            const response = await createLocation(formData).unwrap();

            console.log(response);

            successToast("success", response?.message || "Location Created Successfully");



            navigate(-1);

        } catch (error) {

            console.log(error);

            errorToast("error", error?.data?.message || "Failed To Create Location");

        }
    };

    return (

        <div>

            {/* HEADER */}
            <div className="page-header-breadcrumb all_breadcrumb">

                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">

                    <nav>

                        <h4 className="fw-semibold">
                            Add Location
                        </h4>

                        <ol className="breadcrumb mb-0">

                            <li
                                className="breadcrumb-item active"
                                aria-current="page"
                            >
                                <Link to="/">
                                    Home
                                </Link>
                            </li>

                            <li className="breadcrumb-item">
                                Add Location
                            </li>

                        </ol>

                    </nav>

                </div>

                <div className="page-title fw-semibold fs-18 mb-0">

                    <button
                        type='button'
                        className="btn btn-primary me-2"
                        onClick={() => navigate(-1)}
                    >

                        <span>
                            <i className="fe fe-shopping-cart me-1"></i>
                        </span>

                        Location List

                    </button>

                </div>

            </div>

            {/* FORM */}
            <div className="card">

                <div className="card-body">

                    <form onSubmit={handleSubmit}>

                        <div className="container">

                            <div className="row align-items-end">

                                {/* INPUT */}
                                <div className="col-md-6">

                                    <div className="form-group">

                                        <label>
                                            Enter Location
                                        </label>

                                        <input
                                            type="text"
                                            className='form-control custumform'
                                            placeholder='Enter Location  Name'
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                        />

                                    </div>
                                    <div className="form-group mt-3">
                                        <label>Select State</label>

                                        <select
                                            className="form-control"
                                            name="stateName"
                                            value={formData.stateName}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select State</option>

                                            {stateData?.data?.map((state) => (
                                                <option
                                                    key={state.id}
                                                    value={state.name}
                                                >
                                                    {state.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="form-group mt-3">
                                        <label>Select City</label>

                                        <select
                                            className="form-control"
                                            name="cityName"
                                            value={formData.cityName}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select City</option>

                                            {cityData?.data?.map((city) => (
                                                <option
                                                    key={city.id}
                                                    value={city.name}
                                                >
                                                    {city.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group mt-3">

                                        <label>Status</label>

                                        <select
                                            name="status"
                                            className="form-control"
                                            value={formData.status}
                                            onChange={handleChange}
                                        >

                                            <option value="active">
                                                Active
                                            </option>

                                            <option value="inactive">
                                                Inactive
                                            </option>

                                        </select>

                                    </div>

                                </div>

                                {/* BUTTON */}
                                <div className="col-md-6">

                                    <div className="form-group">

                                        <div className="button_submit">

                                            <button
                                                type="submit"
                                                className='btn btn-primary'
                                            >

                                                {
                                                    isLoading
                                                        ? "Loading..."
                                                        : "Submit"
                                                }

                                            </button>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </form>

                </div>

            </div>

        </div>
    )
}

export default AddLocation